import React, { useMemo } from 'react';
import { isNil, range } from 'lodash';
import rules from './rules';
import useRulesContext from './context';

const DefaultPreview = () => range(0, 10).map((ind) => (
  <div key={`preview-char-${ind}`} className='preview-char' />
));

const Preview = () => {
  const { ruleTypeId } = useRulesContext();

  const PreviewComponent = useMemo(() => {
    if (isNil(ruleTypeId)) {
      return DefaultPreview;
    }
    const rule = rules.find(({ ruleTypesIds }) => ruleTypesIds.includes(ruleTypeId));

    return rule?.PreviewComponent ?? DefaultPreview;
  }, [ruleTypeId]);

  return <PreviewComponent />;
};

export default Preview;
